// extracted by mini-css-extract-plugin
export default {"ag-styles":"K_g","detailCellRenderer":"K_dj"};